import React from 'react';
import { useAuth } from '../providers/AuthProvider';
import { Navigate } from 'react-router-dom';
import { ReactComponent as BackbarLogo } from '../assets/img/backbar-logo-black.svg';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';

const LogIn: React.FC = () => {
  const { isLoggedIn } = useAuth();
  if (isLoggedIn) {
    const path = localStorage.getItem('path');
    return <Navigate to={path || '/forecast/dashboard'} replace={true} />;
  }
  return (
    <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
      <BackbarLogo className="mb-4" />
      <h3>Welcome back!</h3>
      <p style={{ fontSize: '14px' }}>Sign in to your account to continue</p>
      <div className="w-25 p-4 bg-white d-flex flex-column justify-content-center align-items-center ">
        <Button
          className="w-100"
          variant="google"
          onClick={() => {
            window.location.href = process.env.REACT_APP_SERVER_ROOT + '/login/federated/google';
          }}
        >
          <FontAwesomeIcon icon={faGoogle} />
          <span className="ml-3"> Sign in with google </span>
        </Button>
      </div>
    </div>
  );
};

export default LogIn;
